exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".item-8VnhI{position:relative}.item-8VnhI:not(:last-child){margin-right:20px}.item-8VnhI:not(:last-child):after{content:\"\";height:20px;width:1px;background-color:#fff;position:absolute;right:-10px}.title-1fPCg{text-transform:uppercase;font-weight:600}.active-2fcHU{color:#0a81ff !important}.theme-dark .item-8VnhI:not(:last-child):after{background-color:#fff}.theme-light .item-8VnhI:not(:last-child):after{background-color:#b9b9b9}", ""]);

// exports
exports.locals = {
	"item": "item-8VnhI",
	"title": "title-1fPCg",
	"active": "active-2fcHU"
};